<template>
  <v-container v-if="points.length !== 0">
    <v-row>
      <v-col>
        <v-simple-table>
          <thead>
            <td>Hour #</td>
            <td>Hour</td>
            <td>Percent Correct</td>
            <td>ParticiPants</td>
            <td>Total Points</td>
            <td>Rank</td>
            <td>Diff</td>
          </thead>
          <tbody>
          <tr v-for="(hour, index) in points" :key="index" @click="goToHour(hour)" class="clickable">
            <td><b>{{ hour.hourNumber }}</b></td>
            <td>
              {{ hour.triviaDateTime }}
              <v-icon small color="yellow" v-if="hour.speedRound">
                mdi-alarm-light
              </v-icon>
            </td>
            <td>
              {{ hour.percentCorrect }}%
              <v-icon color="orange" v-show="hour.percentCorrect === 100">mdi-halloween</v-icon>
            </td>
            <td>{{ hour.particiPants }}</td>
            <td>
              {{ hour.runningTotal }}
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="error" v-show="!!hour.kvscPoints && hour.kvscPoints !== hour.runningTotal">mdi-alert-circle-outline</v-icon>
                </template>
                <v-span>{{ hour.kvscPoints }}</v-span>
              </v-tooltip>
              <v-icon color="primary" v-show="!hour.kvscPoints">mdi-help-circle-outline</v-icon>
            </td>
            <td>{{ hour.kvscRank }}</td>
            <td>{{ hour.diff }}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <v-skeleton-loader
      type="paragraph, table"
    />
  </v-container>
</template>
<script>
import { forEach, uniq } from 'lodash'

export default {
  data () {
    return {
      points: [],
    }
  },
  computed: {
    questions: function () {
      return this.$store.getters['questions/getAll']()
    },
    latestHour: function () {
      return this.$store.getters['hours/getLatestHour']()
    },
  },
  mounted: async function () {
    await this.$store.dispatch('hours/bindHours')
    await this.$store.dispatch('questions/bindAllQuestions')
    this.calculateTotals()
  },
  methods: {
    calculateTotals: function () {
      this.questions.forEach((hour, index) => {
        let pointsPossible = 0
        let pointsEarned = 0
        let hourNumber = 0
        let hourParticiPants = []

        forEach(hour, (question, key) => {
          if (key !== '$id' && key !== '$priority') {
            hourNumber = question.hourNumber
            pointsPossible += +question.pointValue
            if (question.correct === true) {
              pointsEarned += +question.pointValue
            }

            // build unique array of researchers for hour.
            let quesParticiPants = []
            if (typeof question.totalParticiPants !== 'undefined') {
              quesParticiPants = Object.values(question.totalParticiPants)
            }
            hourParticiPants = hourParticiPants.concat(quesParticiPants)
          }
          hourParticiPants = uniq(hourParticiPants)
        })

        let percentCorrect = 0
        if (pointsPossible > 0) {
          percentCorrect = Math.round(pointsEarned / pointsPossible * 100)
        }

        const hourDetails = this.$store.getters['hours/getHourDetail'](hourNumber)

        let diff = 'NA'
        if (hourDetails &&
            typeof hourDetails.ptsToNext === 'number' &&
            typeof hourDetails.ptsFromPrev === 'number') {
          diff = `-${hourDetails.ptsToNext} / +${hourDetails.ptsFromPrev}`
        }

        // This is "Hour Zero". So that Hour 1 lines up with the start time of Trivia.
        // For 2022, hour zero is 2022-02-18 16:00:00
        let triviaDateTime = new Date(2022, 2, 18, 16)
        triviaDateTime.setHours(triviaDateTime.getHours() + hourNumber)
        triviaDateTime = triviaDateTime.toLocaleDateString('en-US', { weekday: 'short', hour: 'numeric' })

        this.points.push({
          hourNumber: hourNumber,
          triviaDateTime: triviaDateTime,
          percentCorrect: percentCorrect,
          pointsEarned: pointsEarned,
          pointsPossible: pointsPossible,
          particiPants: hourParticiPants.length,
          kvscRank: (hourDetails) ? hourDetails.kvscRank : 'N/A',
          kvscPoints: hourDetails.kvscPointTotal,
          speedRound: hourDetails.speedRound,
          diff: diff,
        })
      })

      this.points.sort(function (b, a) {
        return b.hourNumber - a.hourNumber
      })

      let runningTotal = 0
      this.points.forEach(function (hour) {
        runningTotal += hour.pointsEarned
        hour.runningTotal = runningTotal
      })

      this.points.sort(function (a, b) {
        return b.hourNumber - a.hourNumber
      })
    },
    goToHour: function (hour) {
      this.$router.push(`/hour/${hour.hourNumber}`)
    },
  },
}
</script>

<style scoped lang="scss">
  .clickable {
      cursor: pointer
  }
</style>
